module.exports = __webpack_public_path__ + "img/蒙版组 3@2x.3f111559.webp";